import React from "react";

const LatestNewsSection = () => (
  <section className="progress-section latest-news-section py-5">
    <div className="container">
      <div className="row">
        <div className="col-12 mb-lg-5 mb-0">
          <h2 className="section-title" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
            Latest News & Events
          </h2>
        </div>
      </div>
    </div>
  </section>
);

export default LatestNewsSection;
